import PropTypes from 'prop-types';
import { trans } from '@spotahome/soyuz/client';

import { Button } from '@spotahome/ui-library';
import ListingChipsContainer from '@spotahome/ui-library/src/tenant/components/ListingChipsContainer';
import ListingTitle from '@spotahome/ui-library/src/tenant/components/ListingTitle';
import { formatFeaturesToChipList } from '@spotahome/ui-library/src/tenant/components/PropertyRulesRedesign/utils';

import { ListingSectionObservable } from '../ListingSection';
import ContractBasicsSimplified from '../ContractBasicsSimplified';
import LandlordPoliciesSimplified from '../LandlordPoliciesSimplified';
import ArrivalKeysSimplified from '../ArrivalKeysSimplified';
import CancellationPoliciesSimplified from '../CancellationPoliciesSimplified';

import openPropertyRulesSimplifiedModal from './PropertyRulesSimplifiedModal';

import './PropertyRulesSimplified.scss';

const MAX_VISIBLE_CHIPS = 8;

const PropertyRulesSimplified = ({
  propertyRules = null,
  currency,
  contractType = null,
  contractualPermissions = null,
  documentsPolicy = null,
  minStay = null,
  landlordPolicies = null,
  moveInMoveOutPolicy = null
}) => {
  const propertyFeaturesChips = propertyRules
    ? formatFeaturesToChipList(propertyRules, currency).filter(Boolean)
    : [];

  return (
    <ListingSectionObservable
      section="bookingRequirements"
      className="property-rules-simplified__container"
      bordered={false}
    >
      <ListingTitle
        role="secondary"
        className="property-rules-simplified__section-title"
      >
        {trans('listing.simplification.bottom.landlord-rules.section.title')}
      </ListingTitle>
      {propertyFeaturesChips.length > 0 && (
        <ListingSectionObservable
          section="landlordRules"
          className="property-rules-simplified"
        >
          <ListingTitle role="tertiary">
            {trans('listing.simplification.bottom.landlord-rules.card.title')}
          </ListingTitle>
          <ListingChipsContainer
            chipList={propertyFeaturesChips}
            maxVisibleChips={MAX_VISIBLE_CHIPS}
            showShowMoreButton={false}
            className="property-rules-simplified__chips"
          />
          <Button
            type="button"
            color="link"
            className="property-rules-simplified__view-more"
            onClick={() =>
              openPropertyRulesSimplifiedModal({
                propertyFeaturesChips,
                fullscreenOnMobile: true
              })
            }
          >
            {trans('common.view-more')}
          </Button>
        </ListingSectionObservable>
      )}
      <ContractBasicsSimplified
        contractualPermissions={contractualPermissions}
        contractType={contractType}
        documentsPolicy={documentsPolicy}
        minStay={minStay}
        currency={currency}
      />
      {landlordPolicies && (
        <LandlordPoliciesSimplified landlordPolicies={landlordPolicies} />
      )}
      <ArrivalKeysSimplified moveInMoveOutPolicy={moveInMoveOutPolicy} />
      <CancellationPoliciesSimplified />
    </ListingSectionObservable>
  );
};

PropertyRulesSimplified.propTypes = {
  propertyRules: PropTypes.object,
  currency: PropTypes.string.isRequired,
  contractType: PropTypes.string,
  contractualPermissions: PropTypes.object,
  documentsPolicy: PropTypes.object,
  minStay: PropTypes.number,
  landlordPolicies: PropTypes.string,
  moveInMoveOutPolicy: PropTypes.object
};

export default PropertyRulesSimplified;
